import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BasicLayoutComponent } from './basic-layout/basic-layout.component';
import {
  AccountRoute,
  DashboardRoute,
  ProductsRoute,
  FaqRoute,
  NewInvestmentRoute,
  MoneyAndTransactionsRoute,
  InvestmentsListRoute,
  BlogRoute,
  PersonalInformationRoute,
  ThematicStrategiesRoute,
  CollaboratorRoute,
  EditInvestmentRoute,
  InvestmentProfileRoute,
  DocumentsRoute,
  DraftInvestmentRoute,
  InvestmentChangeDraftRoute,
  InitSignRoute,
  UserNotificationsRoute,
  UnauthRoutes,
  ProductLandingRoute,
} from '../models/routes.model';
import { AuthenticatedGuard } from 'src/guards/authenticated.guard';
import { ValidContractsGuard } from 'src/guards/valid-contracts.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: `/${DashboardRoute.DASHBOARD}`,
    pathMatch: 'full'
  },
  {
    path: '',
    component: BasicLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('../features/auth/auth.module').then(m => m.AuthModule),
        data: { modes: ['bwm']} // todo: bwm only https://gitlab.com/dfcz/bwm-frontend/-/issues/30
      },
      {
        path: NewInvestmentRoute.NEW_INVESTMENT,
        loadChildren: () => import('../features/new-investment/new-investment.module').then(m => m.NewInvestmentModule),
        canActivate: [AuthenticatedGuard, ValidContractsGuard]
      },
      {
        path: DashboardRoute.DASHBOARD,
        loadChildren: () => import('../features/dashboard/dashboard.module').then(m => m.DashboarsModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: AccountRoute.ACCOUNT,
        loadChildren: () => import('../features/account/account.module').then(m => m.AccountModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: ProductsRoute.INVESTMENT_DETAIL,
        loadChildren: () => import('../features/investment-detail/investment-detail.module').then(m => m.InvestmentDetailModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: InvestmentsListRoute.INVESTMENTS,
        loadChildren: () => import('../features/investments-list/investments-list.module').then(m => m.InvestmentsListModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: AccountRoute.ACCOUNT,
        loadChildren: () => import('../features/account/account.module').then(m => m.AccountModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: MoneyAndTransactionsRoute.MONEY_TRANSACTIONS,
        loadChildren: () => import('../features/money-and-transactions/money-and-transactions.module').then(m => m.MoneyAndTransactionsModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: '', // todo - shouldnt emtpy path be at end/after FAQ route?
        loadChildren: () => import('../features/development/development.module').then(m => m.DevelopmentModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: FaqRoute.FAQ,
        loadChildren: () => import('../features/faq/faq.module').then(m => m.FaqModule),
      },
      {
        path: InvestmentProfileRoute.INVESTMENT_PROFILE,
        loadChildren: () => import('../features/investment-profile/investment-profile.module').then(m => m.InvestmentProfileModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: CollaboratorRoute.COLLABORATOR,
        loadChildren: () => import('../features/collaborator/collaborator.module').then(m => m.CollaboratorModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: BlogRoute.BLOG,
        loadChildren: () => import('../features/blog/blog.module').then(m => m.BlogModule),
      },
      {
        path: ThematicStrategiesRoute.THEMATIC_STRATEGIES,
        loadChildren: () => import('../features/thematic-strategies/thematic-strategies.module').then(m => m.ThematicStrategiesModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: PersonalInformationRoute.PERSONAL_INFORMATION,
        loadChildren: () => import('../features/account/account.module').then(m => m.AccountModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: EditInvestmentRoute.EDIT_INVESTMENT,
        loadChildren: () => import('../features/edit-investment/edit-investment.module').then(m => m.EditInvestmentModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: DocumentsRoute.DOCUMENTS,
        loadChildren: () => import('../features/document/document.module').then(m => m.DocumentModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: UserNotificationsRoute.USER_NOTIFICATIONS,
        loadChildren: () => import('../features/user-notifications/user-notifications.module').then(m => m.UserNotificationsModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: DraftInvestmentRoute.DRAFT_INVESTMENT,
        loadChildren: () => import('../features/draft-investment/draft-investment.module').then(m => m.DraftInvestmentModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: InvestmentChangeDraftRoute.INVESTMENT_CHANGE_DRAFT,
        loadChildren: () => import('../features/investment-change-draft/investment-change-draft.module').then(m => m.InvestmentChangeDraftModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: InitSignRoute.INIT_SIGN_WITH_INVESTMENTS,
        loadChildren: () => import('../features/init-sign/init-sign.module').then(m => m.InitSignModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: UnauthRoutes.CLIENT_ADDITION_REDIRECT,
        loadChildren: () => import('../features/client-addition-redirect/client-addition-redirect.module').then(m => m.ClientAdditionRedirectModule),
        canActivate: []
      },
      {
        path: UnauthRoutes.DIP_REDIRECT,
        loadChildren: () => import('../features/dip-withdrawal-confirm/dip-withdrawal-confirm.module').then(m => m.DipWithdrawalConfirmModule),
        canActivate: []
      },
      {
        path: UnauthRoutes.EMAIL_VERIFICATION,
        loadChildren: () => import('../features/email-verification/email-verification.module').then(m => m.EmailVerificationModule),
        canActivate: []
      },
      {
        path: UnauthRoutes.NOTIFICATIONS_UNSUBSCRIBE,
        loadChildren: () => import('../features/notifications-unsubscribe/notifications-unsubscribe.module').then(m => m.NotificationsUnsubscribeModule),
        canActivate: []
      },
      {
        path: UnauthRoutes.PUBLIC_INSTRUMENTS,
        loadChildren: () => import('../features/public-instruments/public-instruments.module').then(m => m.PublicInstrumentsModule),
        canActivate: []
      },
      {
        path: ProductLandingRoute.PRODUCT,
        loadChildren: () => import('../features/product-landing/product-landing.module').then(m => m.ProductLandingModule),
        canActivate: []
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutsRoutingModule { }
